(function () {

  var isMobile = window.matchMedia('(max-width: 749px)').matches;

  /* =========================================
     1. Fade-in on scroll (IntersectionObserver)
     ========================================= */
  var fadeObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = el.dataset.animateDelay || 0;
          setTimeout(function () {
            el.classList.add('is-visible');
          }, Number(delay));
          fadeObserver.unobserve(el);
        }
      });
    },
    { threshold: 0.12 }
  );

  /* =========================================
     2. Concept heading: scale reveal
     ========================================= */
  var conceptObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          conceptObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  /* =========================================
     3. Node One: sticky scroll storytelling
     ========================================= */
  var nodeOuter   = null;
  var nodeSection = null;
  var nodeImg     = null;
  var nodeItems   = [];

  // Each item: { el, startP, endP, fromX, fromY }
  var STORY = [
    { key: 'meta',  startP: 0.00, endP: 0.16, fromX:  0,   fromY:  24 },
    { key: 'title', startP: 0.14, endP: 0.32, fromX: -80,  fromY:  0  },
    { key: 'copy',  startP: 0.30, endP: 0.46, fromX:  0,   fromY:  28 },
    { key: 'desc',  startP: 0.44, endP: 0.60, fromX:  0,   fromY:  28 },
    { key: 'btn',   startP: 0.58, endP: 0.74, fromX:  0,   fromY:  20 },
  ];

  function easeOut(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
  }

  function updateStickyReveal() {
    if (!nodeOuter) return;

    var scrollY     = window.scrollY;
    var outerTop    = nodeOuter.getBoundingClientRect().top + scrollY;
    var scrollable  = nodeOuter.offsetHeight - window.innerHeight;
    if (scrollable <= 0) return;

    var raw      = (scrollY - outerTop) / scrollable;
    var progress = clamp(raw, 0, 1);

    // Text reveals
    STORY.forEach(function (step) {
      if (!step.el) return;
      var p = clamp((progress - step.startP) / (step.endP - step.startP), 0, 1);
      var e = easeOut(p);
      step.el.style.opacity   = e;
      step.el.style.transform =
        'translateX(' + step.fromX * (1 - e) + 'px) translateY(' + step.fromY * (1 - e) + 'px)';
    });
  }

  /* =========================================
     4. Hero image parallax
     ========================================= */
  var heroImg = null;

  function updateHeroParallax() {
    if (!heroImg) return;
    heroImg.style.transform = 'translateY(' + (window.scrollY * 0.28) + 'px)';
  }

  /* =========================================
     5. Unified RAF scroll loop
     ========================================= */
  var ticking = false;

  function onScrollFrame() {
    updateHeroParallax();
    if (!isMobile) updateStickyReveal();
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(onScrollFrame);
      ticking = true;
    }
  }

  /* =========================================
     Init
     ========================================= */
  function init() {
    // Fade-in observers
    document.querySelectorAll('[data-animate]').forEach(function (el) {
      fadeObserver.observe(el);
    });

    // Concept heading scale
    var conceptHeading = document.querySelector('.id-concept__heading');
    if (conceptHeading) conceptObserver.observe(conceptHeading);

    // Hero parallax
    heroImg = document.querySelector('.id-hero__image');

    // Node One sticky
    nodeOuter   = document.querySelector('.id-node-one__outer');
    nodeSection = document.querySelector('.id-node-one');
    nodeImg     = document.querySelector('.id-node-one__image');

    if (nodeOuter && !isMobile) {
      STORY.forEach(function (step) {
        step.el = nodeOuter.querySelector('[data-sr="' + step.key + '"]');
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScrollFrame(); // initial state
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
